import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { SubscriptionInfoModel } from 'src/app/models/subscription-info.model';
import { AccessControlService } from 'src/app/shared/services/access-control.service';
import { SubscriptionService } from 'src/app/shared/services/subscription.service';

@Component({
    selector: 'app-iri-lock',
    templateUrl: './iri-lock.component.html',
    styleUrls: ['./iri-lock.component.scss'],
    standalone: false
})
export class IriLockComponent implements OnInit {
     userRole: string|null = null;
  private subscriptions: Subscription[] = [];
  constructor(
       public accessControlService: AccessControlService
  ) { }

  ngOnInit(): void {
   this.subscriptions.push(SubscriptionService.subscriptionData.subscribe((data: SubscriptionInfoModel) => {
         this.userRole = data.role
      }))
  }

}
